// Pages/Terms/Policies.js
export const policies = {
  categories: {
    generalBusiness: {
      title: "General Business Policies",
      policies: {
      generalPrivacy: {
  title: "General Privacy Policy",
  lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "We at ARO Events (“we,” “our,” or “us”) are committed to safeguarding your privacy. This policy explains how we handle your personal information collected through Future Oil Conference and Supply Chain Ai Conference and our associated websites and services."
      ]
    },
    {
      id: "infoCollect",
      title: "1. Information That We Collect About You",
      content: [
        "We may collect personal details including your name, email address, organization, telephone number, job title, payment information, and other information you provide when registering for or interacting with Future Oil Conference and Supply Chain Ai Conference or other ARO Events services.",
        "We may also collect information automatically, such as your IP address, browser type, operating system, device information, and browsing behavior on our websites."
      ]
    },
    {
      id: "disclosure",
      title: "2. Disclosure",
      content: [
        "We do not sell your personal information. We may disclose your information only in the following cases:",
        "- When required by law or legal process.",
        "- To protect our rights, property, and safety, or that of our users and partners.",
        "- To trusted service providers who perform services on our behalf, such as payment processing, IT support, and communications."
      ]
    },
    {
      id: "location",
      title: "3. Location of Data",
      content: [
        "Your information may be stored and processed in countries outside your country of residence, including where data protection laws may differ. We ensure appropriate safeguards are in place to protect your personal information when transferred internationally."
      ]
    },
    {
      id: "security",
      title: "4. Security",
      content: [
        "We implement appropriate technical and organizational measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction. However, no data transmission over the Internet can be guaranteed as 100% secure."
      ]
    },
    {
      id: "rights",
      title: "5. Your Rights",
      content: [
        "Depending on applicable law, you may have the right to:",
        "- Access the personal data we hold about you.",
        "- Request correction of inaccurate or incomplete information.",
        "- Request deletion of your personal data.",
        "- Restrict or object to our processing of your data.",
        "- Request a copy of your data in a portable format.",
        "To exercise these rights, please contact us at info@aroevents.com."
      ]
    },
    {
      id: "retention",
      title: "6. Retention",
      content: [
        "We retain personal data only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, comply with our legal obligations, resolve disputes, and enforce our agreements."
      ]
    },
    {
      id: "choices",
      title: "7. Choices",
      content: [
        "You may opt out of receiving promotional communications from us by following the unsubscribe instructions in our emails or by contacting us directly at info@aroevents.com.",
        "Please note that you may still receive essential administrative messages related to your registration or participation in Future Oil Conference and Supply Chain Ai Conference."
      ]
    },
    {
      id: "cookies",
      title: "8. Cookies",
      content: [
        "Our websites may use cookies and similar technologies to improve functionality, analyze traffic, and personalize content. You can control cookies through your browser settings. Disabling cookies may affect your experience on our websites."
      ]
    },
    {
      id: "children",
      title: "9. Children’s Data",
      content: [
        "Future Oil Conference and Supply Chain Ai Conference and related ARO Events services are not directed to children under the age of 16. We do not knowingly collect personal data from children. If you believe we have inadvertently collected such data, please contact us immediately at info@aroevents.com."
      ]
    },
    {
      id: "thirdParties",
      title: "10. Third Parties",
      content: [
        "Our websites may include links to third-party websites and services. We are not responsible for the privacy practices of these third parties. We encourage you to review their privacy policies before providing any personal information."
      ]
    },
    {
      id: "misc",
      title: "11. Miscellaneous",
      content: [
        "We may update this Privacy Policy from time to time to reflect changes in our practices, technologies, legal requirements, or other factors. Updates will be posted on this page with the revised date."
      ]
    },
    {
      id: "contact",
      title: "12. Contact",
      content: [
        "If you have any questions, concerns, or requests regarding this Privacy Policy or our handling of your information, please contact us at:",
        "ARO Events",
        "Email: info@aroevents.com"
      ]
    }
  ]
},
      cookiePolicy: {
  title: "Cookie Policy",
  lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "ARO Events (“we,” “our,” or “us”) respects the privacy of users who browse our website. This policy explains how we use cookies and similar tracking technologies on our websites, apps, and services related to the Future Oil Conference and Supply Chain Ai Conference."
      ]
    },
    {
      id: "whatAreCookies",
      title: "1. What Are Cookies?",
      content: [
        "A cookie is a small text file containing a unique identifier sent by a web server to your browser or device when you visit a website.",
        "Cookies and similar technologies help websites function efficiently and collect information about your online preferences.",
        "Some pages may include web beacons (also called clear gifs, tags, or pixels) that count users visiting our pages. These beacons collect limited information, such as cookie number, page view date/time, and page description, and may be used by third-party advertisers."
      ]
    },
    {
      id: "howWeUseCookies",
      title: "2. How We Use Cookies",
      content: [
        "We use cookies and tracking technologies to customize content and advertising, provide social media features, and analyze visitor behavior on our websites.",
        "Third-party tracking and advertising providers may collect and share usage information with us to measure advertising effectiveness, track page usage, and help target content and ads relevant to you."
      ]
    },
    {
      id: "cookieTypes",
      title: "3. Cookie Types & Their Purposes",
      content: [
        "- **Essential cookies:** Required for basic website functions, such as recognizing users and remembering sign-in details.",
        "- **Targeting cookies:** Used to deliver relevant ads, limit ad frequency, and measure ad campaign effectiveness. Third-party companies may use these cookies to serve advertising to your device.",
        "- **Social media cookies:** Enable sharing of content on platforms like Facebook, LinkedIn, Instagram, and Twitter. These cookies are controlled by the social media provider.",
        "- **Performance cookies:** Collect information on website usage to improve navigation and fix technical issues.",
        "- **Functionality cookies:** Remember user preferences, such as language, region, and customizations, to personalize website content."
      ]
    },
    {
      id: "rejectCookies",
      title: "4. How to Reject Cookies",
      content: [
        "You can prevent cookies from being set or delete existing cookies using your browser settings. Disabling cookies may limit access to certain areas or features of our websites.",
        "For instructions on managing cookies, please refer to your browser’s support page:",
        "- Explorer: http://windows.microsoft.com/en-gb/internet-explorer/delete-manage-cookies#ie=ie-11",
        "- Firefox: https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences",
        "- Chrome: https://support.google.com/chrome/answer/95647?hl=en",
        "- Safari: https://support.apple.com/kb/PH19214?locale=en_GB",
        "To opt-out of Google Analytics cookies, install the browser plug-in here: https://tools.google.com/dlpage/gaoptout"
      ]
    },
    {
      id: "changes",
      title: "5. Changes to This Cookie Policy",
      content: [
        "We may update this Cookie Policy at any time. Updated versions will be posted here with the revised effective date. Your continued use of our websites, apps, or services signifies your acceptance of these changes."
      ]
    },
    {
      id: "contact",
      title: "6. Contact",
      content: [
        "If you have any questions about this Cookie Policy or how we use cookies, please contact us at:",
        "ARO Events",
        "Email: info@aroevents.com"
      ]
    }
  ]
},
  
        termsGeneral: {
          title: "Terms and Conditions for General Usage",
          lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "Welcome to ARO Events! We encourage you to take advantage of the content and features available on our Future Oil Conference and Supply Chain Ai Conference website, applications, products, services, events, and experiences (together, “ARO Events Offerings”).",
        "Please read these non-negotiable terms of use carefully before using the website. By continuing to use the website, you (the “user”) agree to be bound by these terms of use.",
        "If you purchase any subscription products or services from ARO Events and its affiliates (“Services”), the terms for those Services will be set forth in a separate agreement between you and ARO Events. These TERMS OF USE do not change or limit your rights and obligations under that agreement."
      ]
    },
    {
      id: "websiteContent",
      title: "Website Content and Copyright",
      content: [
        "This website and all translations are the property of ARO Events. ARO Events grants users the right to access and use the website for internal information purposes, provided users do not alter, copy, disseminate, redistribute, or republish any content without written approval from ARO Events."
      ]
    },
    {
      id: "changesToWebsite",
      title: "Changes or Updates to the Website",
      content: [
        "ARO Events reserves the right to change, update, or discontinue any aspect of this website at any time without notice. Continued use after changes constitutes agreement to the modified Terms of Use."
      ]
    },
    {
      id: "privacy",
      title: "Privacy",
      content: [
        "Please review our Privacy Policy, which also governs your visit to the ARO Events websites, to understand our practices."
      ]
    },
    {
      id: "electronicCommunications",
      title: "Electronic Communications",
      content: [
        "ARO Events does not make warranties, express or implied, including merchantability or fitness for a particular purpose. While reasonable steps are taken to screen for viruses or other harmful code, we cannot guarantee the website will be free from infection or code vulnerabilities."
      ]
    },
    {
      id: "thirdPartyLinks",
      title: "Third-Party Links",
      content: [
        "ARO Events Offerings may contain links to third-party websites. These links are provided for convenience only. ARO Events does not endorse or accept responsibility for these sites. Users should address any concerns to the respective website administrator."
      ]
    },
    {
      id: "limitationOfLiability",
      title: "Limitation of Liability",
      content: [
        "ARO Events is not liable for damages of any kind, including direct, incidental, or consequential damages arising out of the use or inability to use this website, or errors, omissions, or inaccuracies in the content."
      ]
    },
    {
      id: "termination",
      title: "Termination",
      content: [
        "Users agree to comply with all applicable laws and not take actions compromising the security or viability of the website. ARO Events may terminate user access at any time for any reason. Terms regarding Disclaimer of Warranty, Accuracy of Information, Indemnification, and Third-Party Rights survive termination."
      ]
    },
    {
      id: "indemnification",
      title: "Indemnification",
      content: [
        "Users agree to indemnify and hold harmless ARO Events, its affiliates, licensors, officers, directors, employees, and agents from all losses, damages, and costs, including reasonable attorneys’ fees, arising from use or misuse of the website."
      ]
    },
    {
      id: "thirdPartyRights",
      title: "Third-Party Rights",
      content: [
        "Disclaimer of Warranty, Limitation of Liability, and Indemnification terms benefit ARO Events, its affiliates, licensors, employees, and agents, each of whom may enforce these terms against users."
      ]
    },
    {
      id: "generalProvisions",
      title: "General Provisions",
      content: [
        "Any provision inconsistent with or adding to these Terms of Use is void. If a term is invalid, remaining terms remain in full force and effect."
      ]
    },
    {
      id: "governingLaw",
      title: "Governing Law and Jurisdiction",
      content: [
        "These Terms of Use are governed by the laws of India, and disputes shall be subject to the exclusive jurisdiction of courts and authorities in Delhi."
      ]
    },
    {
      id: "privacyStatement",
      title: "Privacy Statement",
      content: [
        "User privacy is important to ARO Events. Information provided during registration is used to personalize the online experience, process orders, and track interests. ARO Events does not share personal information with third parties."
      ]
    },
    {
      id: "monitoring",
      title: "Monitoring",
      content: [
        "ARO Events reserves the right to monitor and track visits to the website."
      ]
    },
    {
      id: "restrictionOnUse",
      title: "Restriction on Use",
      content: [
        "Users must not:",
        "(i) violate the site’s security or attempt unauthorized access to systems or networks;",
        "(ii) impose disproportionate burdens on the site or infrastructure;",
        "(iii) use automated devices or methods to access, index, or copy content without prior written consent;",
        "(iv) forge headers or manipulate identifiers to disguise content origin;",
        "(v) use content for training or developing AI, machine learning, or derivative works infringing intellectual property rights."
      ]
    },
    {
      id: "copyrightClaims",
      title: "Claims of Copyright Infringement",
      content: [
        "ARO Events respects intellectual property rights. Users must not post content or interact in ways that infringe on proprietary rights. Only post content you own or have permission to use."
      ]
    }
  ]
},
paymentPortalTerms: {
  title: "Payment Portal Terms",
  lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "Welcome to ARO Events! We encourage you to take advantage of the content and features available on the Future Oil Conference and Supply Chain Ai Conference website and all ARO Events websites and affiliates.",
        "Please read these non-negotiable terms and conditions carefully before using the website. By continuing to use the website, you (the “user”) agree to be bound by ARO Events’ Terms of Use.",
        "Payments processed on this website are subject to the terms set forth in a separate sales contract between you and ARO Events.",
        "If you have not yet purchased services from ARO Events or are not already a client, we encourage you to contact us to learn more about the benefits and value that ARO Events can provide."
      ]
    },
    {
      id: "paymentTerms",
      title: "Payment Terms",
      content: [
        "By submitting payment, you authorize ARO Events to charge the credit or debit card provided for the invoice entered in the Payment Information Section, and certify that you are the authorized user of the card.",
        "You acknowledge that you have read and agree to the Terms of Use."
      ]
    },
    {
      id: "currencyExchange",
      title: "Currency Exchange Rate Disclaimer",
      content: [
        "If paying with an international Visa, Mastercard, or American Express card, the purchase price may fluctuate due to exchange rates.",
        "Your bank or card issuer may also charge foreign conversion fees, which could increase the total cost of your purchase.",
        "ARO Events is not liable for any gain or loss incurred due to currency exchange adjustments made by your bank or card issuer."
      ]
    },
    {
      id: "disputes",
      title: "Disputes",
      content: [
        "If a payment issue arises that cannot be resolved with ARO Events and you dispute a credit or debit card charge, your electronic statement may be used as evidence that the charge is valid.",
        "For any payment issues, please contact the ARO Events Finance Team at info@aroevents.com."
      ]
    },
    {
      id: "troubleshooting",
      title: "Troubleshooting Credit and Debit Card Payments",
      content: [
        "Ensure your card is activated if it is new or recently reissued.",
        "Remove dashes or spaces from the account number when entering payment.",
        "If issues persist, contact your card issuer’s customer service for authorization. In most cases, banks resolve problems within 24 hours, allowing the next automatic payment attempt to succeed.",
        "For additional payment options or portal issues, contact the ARO Events Finance Team at info@aroevents.com."
      ]
    },
    {
      id: "accountVerification",
      title: "Account Verification",
      content: [
        "Ensure the billing address on your order matches your credit card account information to prevent delays.",
        "If you have recently moved or are unsure of your statement address, contact your card-issuing bank to confirm."
      ]
    },
    {
      id: "securityCodes",
      title: "Security Codes",
      content: [
        "The card security code (CVV) is a unique three- or four-digit number printed on the front (American Express) or back (Mastercard, Visa, Discover) of your card."
      ]
    },
    {
      id: "secretCode",
      title: "Secret Code",
      content: [
        "A secret code is a unique eight-digit number printed on the invoice generated by the system for all purchases, providing additional transaction security."
      ]
    }
  ]
},
fraudulentCommunications: {
  title: "Be Aware of Fraudulent Communications",
  lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "You may be contacted by unscrupulous individuals pretending to work for ARO Events to obtain your personal information, money, or payment information. These communications may include ARO Events branding, but they are not legitimate."
      ]
    },
    {
      id: "warningSigns",
      title: "Warning Signs of Fraudulent Communications",
      content: [
        "To help identify fraudulent communications, please note the following:",
        "- We will NEVER ask you to wire money, send cash, or provide your bank account information.",
        "- We will NEVER send you payment in advance for activities related to employment with ARO Events.",
        "- We will NEVER ask you to act as a mystery or secret shopper; we do not conduct this type of research.",
        "- We will NEVER request personal information or payment for ARO Events services via LinkedIn or any other social media platform."
      ]
    },
    {
      id: "legitimateEmails",
      title: "Legitimate Emails",
      content: [
        "Official emails from ARO Events only come from addresses in the format: firstname.lastname@aroevents.com.",
        "If you receive a suspicious email claiming to be from ARO Events, do not reply or respond, as this may confirm your email account as active and result in more spam.",
        "For verification, please contact the ARO Events team directly at info@aroevents.com."
      ]
    },
    {
      id: "additionalResources",
      title: "Additional Resources",
      content: [
        "For more information on recent scams and warning signs, please visit the Federal Trade Commission (FTC) website."
      ]
    }
  ]
},
emailCommunicationPseudonymPolicy: {
  title: "Email Communication & Pseudonym Policy",
  lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "ARO Events (“we,” “us,” or “our”) is committed to ethical and transparent business practices while respecting client privacy. This policy outlines guidelines for using pseudonyms in B2B interactions, specifically email marketing for the Future Oil Conference and Supply Chain Ai Conference."
      ]
    },
    {
      id: "reasonsForPseudonyms",
      title: "Reasons for Using Pseudonyms (with Legal Considerations)",
      content: [
        "- **Protecting Employee Privacy (CAN-SPAM Act):** Using pseudonyms helps prevent employees from being overwhelmed with direct replies when sending high-volume event promotion emails. All emails must clearly disclose ARO Events and contact information in the signature or footer.",
        "- **Brand Differentiation (Trademark Law):** Campaign-specific pseudonyms may be used to tailor messaging for targeted marketing initiatives while maintaining ARO Events’ brand identity, without infringing on existing trademarks.",
        "- **Client Preference (GDPR and CCPA Considerations):** Clients may request pseudonyms for privacy reasons. ARO Events will respect these preferences while maintaining a record linking the pseudonym to ARO Events to comply with data subject access requests."
      ]
    },
    {
      id: "additionalLegalConsiderations",
      title: "Additional Legal Considerations",
      content: [
        "- **Misrepresentation:** Pseudonyms will never be used to misrepresent the company, services, or qualifications. All information provided will be truthful and accurate.",
        "- **Anti-Spam Laws (CAN-SPAM, CASL):** All applicable anti-spam regulations will be followed, including obtaining verifiable consent and providing clear unsubscribe options."
      ]
    },
    {
      id: "ethicalBusinessPractices",
      title: "Ethical Business Practices",
      content: [
        "- **Honesty and Integrity:** All communication, including pseudonym usage, will adhere to honesty and integrity.",
        "- **Client Relationships:** Transparency and clear communication are key to building trust with clients.",
        "- **Avoiding Deception:** Pseudonyms will not be used to deceive or mislead clients about ARO Events offerings or intentions."
      ]
    },
    {
      id: "transparency",
      title: "Transparency",
      content: [
        "- **Disclosure Policy:** Pseudonym usage will be disclosed upon client request and proactively when beneficial.",
        "- **Accessibility of Information:** Marketing materials, emails, and the website will prominently display the legal company name, ARO Events, and relevant contact/legal information."
      ]
    },
    {
      id: "codeOfConduct",
      title: "Code of Conduct",
      content: [
        "- **Employee Training:** Employees will undergo training on ethical pseudonym usage and relevant laws (CAN-SPAM, GDPR).",
        "- **Following Guidelines:** All employees communicating with clients must follow the outlined guidelines."
      ]
    },
    {
      id: "clientRelationships",
      title: "Client Relationships",
      content: [
        "- **Building Trust:** Transparency regarding pseudonym use strengthens client relationships.",
        "- **Responsiveness:** ARO Events will respond promptly to client inquiries about pseudonyms used in emails."
      ]
    },
    {
      id: "privacyAndSecurity",
      title: "Privacy and Security",
      content: [
        "- **Client Data Protection (GDPR and CCPA):** All applicable data protection regulations will be followed.",
        "- **Data Security:** Appropriate security measures are implemented to protect client data from unauthorized access, disclosure, alteration, or destruction."
      ]
    },
    {
      id: "departmentCommunications",
      title: "Department Communications",
      content: [
        "- **Internal Communication:** Departments maintain clear communication regarding pseudonym campaigns to ensure consistent messaging.",
        "- **Record Keeping:** Clear records of pseudonym usage will be maintained to comply with data privacy regulations and client requests."
      ]
    },
    {
      id: "industryStandards",
      title: "Industry Standards",
      content: [
        "- **Research:** ARO Events stays updated on best practices regarding pseudonym use in B2B communication.",
        "- **Compliance:** Policies align with relevant industry standards and guidelines from event planning or marketing associations."
      ]
    },
    {
      id: "review",
      title: "Review",
      content: [
        "This policy will be reviewed periodically to ensure effectiveness and compliance with evolving legal, ethical, and industry standards. Updates will be made as needed to maintain transparency and trust in all B2B email communications."
      ]
    }
  ]
}
},
    },
    conferencePolicies: {
      title: "Conference Policies",
      policies: {
        
    conferencePrivacyPolicy: {
  title: "Conference Privacy Policy",
  lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "ARO Events and its affiliates are committed to protecting your information. This Privacy Notice describes how we collect and use personal information in relation to ARO Events websites, applications, products, services, events, and experiences that reference this Privacy Notice (together, “ARO Events Offerings”).",
        "This policy applies between you, the user, and ARO Events, the owner and provider of this website. By accessing this website, you agree to the collection and use of your information as described herein."
      ]
    },
    {
      id: "purpose",
      title: "Purpose of This Privacy Policy",
      content: [
        "This policy explains how we collect and use personal information, and your rights and choices regarding that information.",
        "It applies when you:",
        "- Express interest in or register for ARO Events conferences, products, tickets, newsletters, webinars, e-books, or other services;",
        "- Attend virtual or in-person conferences and expos;",
        "- Visit our websites, social media sites, or event websites."
      ]
    },
    {
      id: "informationUsage",
      title: "What Do We Do With Your Information?",
      content: [
        "When you purchase tickets, we collect information you provide such as name, address, contact number, and email address.",
        "When browsing our website, we automatically receive your IP address and device/browser information.",
        "With your permission, we may send emails about upcoming events, news, or updates."
      ]
    },
    {
      id: "consent",
      title: "Consent",
      content: [
        "Providing personal information to complete a transaction implies consent to collect and use it for that purpose.",
        "For secondary purposes like marketing, we will seek explicit consent or provide an opt-out option.",
        "You may withdraw consent at any time by contacting info@aroevents.com."
      ]
    },
    {
      id: "dataProtection",
      title: "Data Protection",
      content: [
        "All personal data is processed in accordance with ARO Events’ Privacy Policy.",
        "For more information, visit: [ARO Events Privacy Policy]."
      ]
    },
    {
      id: "disclosure",
      title: "Disclosure",
      content: [
        "We may disclose personal information if required by law or if you violate our Terms of Service."
      ]
    },
    {
      id: "payment",
      title: "Payment",
      content: [
        "Payments are processed via Stripe or other authorized payment processors. Payment data is encrypted in compliance with PCI-DSS standards.",
        "Both ARO Events and the payment processors act as data controllers for the transaction and share information as necessary to provide services.",
        "For more details, see the payment processor’s privacy policy."
      ]
    },
    {
      id: "thirdPartyServices",
      title: "Third-Party Services",
      content: [
        "Third-party providers only collect and use information necessary to perform their services.",
        "Providers may be in different jurisdictions, subjecting your information to local laws. You should review their privacy policies before proceeding with transactions."
      ]
    },
    {
      id: "security",
      title: "Security",
      content: [
        "We take reasonable precautions and follow industry best practices to protect personal information from loss, misuse, unauthorized access, disclosure, alteration, or destruction."
      ]
    },
    {
      id: "cookies",
      title: "Cookies",
      content: [
        "We use cookies and tracking technologies to maintain sessions, customize content, provide social media features, and analyze website usage. This information is not used to personally identify you on other websites.",
        "More details are available in our Privacy & Cookie Policy."
      ]
    },
    {
      id: "ageOfConsent",
      title: "Age of Consent",
      content: [
        "By using this site, you represent that you are at least the age of majority in your jurisdiction, or that you have provided consent for minor dependents to use the site."
      ]
    },
    {
      id: "changes",
      title: "Changes to This Privacy Policy",
      content: [
        "We reserve the right to modify this policy at any time. Updates take effect immediately upon posting.",
        "Material changes will be communicated on this page to ensure you are aware of how your information is collected, used, and disclosed."
      ]
    },
    {
      id: "contact",
      title: "Questions and Contact Information",
      content: [
        "For inquiries, corrections, or deletion requests regarding personal information, contact our privacy team at info@aroevents.com – ATTENTION: ARO Events Legal."
      ]
    }
  ]
},
     conferenceTermsConditions: {
  title: "Conference Terms and Conditions",
  lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "This document sets out the terms and conditions upon which ARO Events sells and supplies the services listed on this website. Please read carefully before confirming your order."
      ]
    },
    {
      id: "contractWithYou",
      title: "Our Contract With You",
      content: [
        "If you purchase subscriptions, products, or services from ARO Events and its affiliates, the terms for those services will be set forth in a separate sales contract ('Contract') between you and ARO Events. These Terms & Conditions do not override or limit your rights under the sales contract. Any variation must be agreed in writing."
      ]
    },
    {
      id: "payment",
      title: "Payment",
      content: [
        "Payment of delegate, speaker, exhibitor, and sponsor fees is due 30 days after the invoice date, or immediately if registration is within one month of the event.",
        "Full payment is required to confirm booking. Fees are fixed and subject to any additional service charges and applicable taxes.",
        "All fees must be paid in full without deduction, counterclaim, or set-off."
      ]
    },
    {
      id: "cancellations",
      title: "Cancellations",
      content: [
        "1. **General Cancellation Terms:** Written cancellations received 30 days or more before the event will receive a 50% refund. Cancellations 29 days or less are non-refundable. Substitutes may be made at any time.",
        "2. **Organizer Rights and Rescheduling:** ARO Events may postpone, amend, or alter the event’s timing, location, or content as necessary. No refunds are issued if the event is rescheduled within 12 months.",
        "3. **Access and Payment:** Access is contingent upon full payment. Non-payment may result in denied entry.",
        "4. **Refunds for Organizer Cancellations:** Full refunds are issued if ARO Events cancels an event.",
        "5. **Liabilities and Costs:** ARO Events is not liable for indirect costs (e.g., travel or accommodation) due to schedule changes. Refunds for cancellations may take up to 30 business days.",
        "6. **Venue and Personal Responsibility:** ARO Events disclaims responsibility for venue conditions, property damage, or personal injuries."
      ]
    },
    {
      id: "alterationOfPackage",
      title: "Alteration of the Advertised Package",
      content: [
        "ARO Events will use best efforts to adhere to the advertised agenda and venue but may make alterations, omissions, or date changes if necessary. Changes will be communicated via email in advance."
      ]
    },
    {
      id: "administration",
      title: "Administration",
      content: [
        "Event agendas are accurate at the time of issue but may be amended. ARO Events is not liable for theft, loss, or damage to personal property. Materials are provided 'as is' without warranty.",
        "ARO Events owns all intellectual property in event materials and delegate lists. Recording or photography of the event is prohibited.",
        "Attendees must comply with all applicable laws and health/safety requirements."
      ]
    },
    {
      id: "dataProtection",
      title: "Data Protection",
      content: [
        "Personal data will be processed in accordance with the ARO Events Privacy Policy."
      ]
    },
    {
      id: "forceMajeure",
      title: "Force Majeure",
      content: [
        "ARO Events is not liable for delays or failures due to circumstances beyond its control, including technical failures, natural disasters, pandemics, strikes, or government restrictions."
      ]
    },
    {
      id: "grantOfRightsAndReservations",
      title: "Grant of Rights and Reservations",
      content: [
        "Attendees are granted a license to use Organizer Branding and Sponsorship Rights as outlined in the contract. All other rights remain with ARO Events. Exclusive rights granted in contracts will not be shared with third parties unless specified.",
        "ARO Events retains the right to use Sponsor Branding for promotion and exploitation of the event."
      ]
    },
    {
      id: "contentLiability",
      title: "Content Liability",
      content: [
        "ARO Events is not responsible for content appearing on attendee websites. Attendees agree to defend and indemnify ARO Events against any claims arising from such content."
      ]
    },
    {
      id: "limitationOfLiability",
      title: "Limitation of Liability",
      content: [
        "ARO Events shall not be liable for special, consequential, or incidental damages, including lost profits or loss of use, even if advised of the possibility.",
        "Terms are subject to local laws and jurisdiction as specified in contracts or booking forms."
      ]
    },
    {
      id: "contact",
      title: "Contact",
      content: [
        "For queries regarding Terms & Conditions, contact info@aroevents.com."
      ]
    }
  ]
},
codeOfConduct: {
  title: "Code of Conduct",
  lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "ARO Events is committed to fostering a professional, inclusive, and respectful environment at all of our events. This Code of Conduct applies to all attendees, whether participating in person or virtually, and outlines the standards we expect to maintain. By attending or registering for a Future Oil Conference and Supply Chain Ai Conference event, all Participants consent to abide by this policy."
      ]
    },
    {
      id: "scope",
      title: "Scope",
      content: [
        "This Code of Conduct applies to:",
        "- Any event (including digital/virtual events) organized or hosted by ARO Events or its affiliates, including conferences, forums, webinars, and exhibitions.",
        "- All Participants, including employees, customers, delegates, speakers, volunteers, interns, guests, vendors, contractors, exhibitors, and other attendees."
      ]
    },
    {
      id: "standardsOfConduct",
      title: "Standards of Conduct",
      content: [
        "All Participants are expected to:",
        "- Respect Others: Treat all individuals with courtesy, dignity, and respect, irrespective of their background, identity, or role.",
        "- Maintain Professionalism: Behave professionally at all times, respecting the event’s purpose, property, and the rights of others.",
        "- Follow the Law: Abide by all applicable local, state, and federal laws, including those concerning intellectual property, privacy, competition, and antitrust.",
        "- Accurate Identity: Register with true personal information and use your real identity in all interactions.",
        "- Protect Privacy: Refrain from capturing or sharing photos, videos, or recordings without consent.",
        "- Dress Code: Wear appropriate attire for a professional setting, including virtual events.",
        "- Inclusive Language: Use respectful and inclusive language in all communications and sessions, avoiding offensive or discriminatory language.",
        "- Environmental Responsibility: Follow any sustainability guidelines provided, such as minimizing waste, recycling, or conserving resources during the event."
      ]
    },
    {
      id: "antiHarassmentPolicy",
      title: "Anti-Harassment Policy",
      content: [
        "ARO Events has a zero-tolerance policy for harassment of any kind, including:",
        "- Unwelcome comments, jokes, or gestures related to a person’s race, gender, sexual orientation, disability, or appearance.",
        "- Inappropriate physical contact, deliberate intimidation, or unwelcome sexual attention.",
        "- Stalking or following individuals during the event.",
        "- Sustained disruption of talks or other event activities.",
        "- Inappropriate use of sexual imagery, whether in presentations, online discussions, or printed materials.",
        "Zero Tolerance for Retaliation: No one will be retaliated against for reporting harassment or other violations of this policy in good faith.",
        "Anonymous Reporting: Reports can be sent confidentially to info@aroevents.com."
      ]
    },
    {
      id: "unacceptableBehavior",
      title: "Unacceptable Behavior",
      content: [
        "Unacceptable behaviors include, but are not limited to:",
        "- Harassment and Discrimination: Any unwelcome conduct based on race, gender, sexual orientation, disability, religion, age, national origin, or other protected characteristics.",
        "- Inappropriate Behavior: Deliberate intimidation, stalking, inappropriate physical contact, and unwelcome sexual attention, in person or online.",
        "- Disruption: Sustained interruption of presentations, sessions, or other event activities.",
        "- Offensive Speech or Actions: Boisterous or lewd behavior, offensive language, and any form of hate speech or slurs.",
        "- Improper Use of Materials: Display or distribution of content without proper permission, including intellectual property, media, or promotional materials.",
        "- Impairment: Participating in an event while intoxicated or under the influence of illegal substances.",
        "- Unauthorized Access: Sharing your event credentials (badge or virtual login) with others or misrepresenting your identity."
      ]
    },
    {
      id: "consequences",
      title: "Consequences of Unacceptable Behavior",
      content: [
        "ARO Events reserves the right to take appropriate action, including:",
        "- Immediate expulsion from the event without warning or refund.",
        "- Permanent exclusion from future ARO Events.",
        "- Referral to law enforcement if necessary.",
        "Participants must comply immediately when asked to stop any unacceptable behavior. ARO Events also reserves the right to remove any Participant who violates venue or digital platform policies."
      ]
    },
    {
      id: "reportingViolations",
      title: "Reporting Violations",
      content: [
        "If you experience or witness any unacceptable behavior, harassment, or violation of this Code of Conduct, report it immediately through the following channels:",
        "- Email: info@aroevents.com",
        "- Anonymous Reporting: info@aroevents.com",
        "- On-site: Contact any ARO Events staff member for assistance."
      ]
    }
  ]
},
mediaPartnership: {
  title: "Terms and Conditions for Media Partnerships",
  lastUpdated: "July 15, 2025",
  sections: [
    {
      id: "introduction",
      title: "Introduction",
      content: [
        "This Media Partnership Agreement is entered into between ARO Events and [Media Partner]. The purpose of this partnership is to promote and publicize the [Name of Event] organized by ARO Events."
      ]
    },
    {
      id: "aroObligations",
      title: "ARO Events Obligations",
      content: [
        "ARO Events shall provide the Media Partner with the following (if applicable & negotiable):",
        "- Supporter level branding on event days and on our event website which attracts thousands of unique visitors.",
        "- Exclusive discount for members/subscribers.",
        "- 2 media delegates complimentary pass(es), which include:",
        "  - Full access to all conference days.",
        "  - Access to all networking activities.",
        "  - Access to the post-event presentations viewer."
      ]
    },
    {
      id: "mediaPartnerObligations",
      title: "Media Partner Obligations",
      content: [
        "The Media Partner shall provide the following in return (if applicable & negotiable):",
        "- Event banner/information on your homepage and/or event pages (banner to be supplied by ARO Events).",
        "- An announcement on your social networks (e.g., LinkedIn Official Page).",
        "- Promote ARO Events as an organizer: https://www.aroevents.com/"
      ]
    },
    {
      id: "exclusivityDuration",
      title: "Exclusivity and Duration",
      content: [
        "This media partnership is exclusive for the [Name of Event] and is valid from [Start Date] to [End Date]."
      ]
    },
    {
      id: "useOfLogos",
      title: "Use of Logos and Branding",
      content: [
        "Both ARO Events and the Media Partner agree to use each other's logos, with prior approval, solely for the purpose of promoting the [Name of Event]."
      ]
    },
    {
      id: "termination",
      title: "Termination",
      content: [
        "Either party may terminate this Agreement with written notice in the event of a material breach by the other party. The termination will take effect [Number of Days] days after the notice."
      ]
    },
    {
      id: "confidentiality",
      title: "Confidentiality",
      content: [
        "Both parties agree to keep any confidential information exchanged during this partnership confidential."
      ]
    },
    {
      id: "entireAgreement",
      title: "Entire Agreement",
      content: [
        "This Agreement represents the entire understanding between the parties concerning the subject matter herein and supersedes all prior discussions, negotiations, and agreements."
      ]
    },
    {
      id: "disclaimer",
      title: "Disclaimer",
      content: [
        "No part of this document/website may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without prior written permission of ARO Events.",
        "©2025 ARO Events and its affiliates. All rights reserved."
      ]
    }
  ]
}

      },
    },
  },
};
